module.exports = __webpack_public_path__ + "static/Slide01-de9a5d1dc623790813a5063fab73a8dd.png";